import * as React from 'react';
import { ErrorWrapper } from '../../ErrorWrapper';
import { fairPlayIcon } from '../../../icons';
import { Link } from '../../../../../../common/Link';
import { IDENTIFICATION_LINK } from './constants';

interface IInitialProps {
  serviceName: string;
  onClickAccept(): void;
}

export const Initial = ({ serviceName }: IInitialProps) => {
  return (
    <ErrorWrapper icon={fairPlayIcon}>
      Услуга {serviceName} доступна только для аккаунтов с{' '}
      <Link href={IDENTIFICATION_LINK} target="_blank" rel="noreferrer">
        идентификацией по документам
      </Link>
      .
    </ErrorWrapper>
  );
};
